import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useGraphneAPI } from '@nexelem/graphne-api';
import { useCustomToast } from '@nexelem/snackbar';
import { useCustomTranslation } from '../../hooks';
import { taskDetailsQueryKey } from './useGraphneTaskDetails';

export const useGraphneTaskRemoveFromPlan = (taskId: string, taskName: string) => {
  const graphneAPI = useGraphneAPI();
  const displayToast = useCustomToast();
  const { tWrapper } = useCustomTranslation('products.productionPlan.removeFromPlanModal');
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ['remove-task-from-plan', taskId],
    mutationFn: () => graphneAPI.deleteGraphneProductionPlanEntriesTaskid({ taskId }),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: taskDetailsQueryKey(taskId) });
      displayToast({
        toastType: 'success',
        message: tWrapper('successToastMessage', { taskName: taskName }),
      });
    },
    onError: () => {
      displayToast({
        toastType: 'error',
        message: tWrapper('errorToastMessage'),
      });
    },
  });
};
